"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TraitEntryDateTime = void 0;
var irt_1 = require("@playq/irt");
var TraitEntryBase_1 = require("./TraitEntryBase");
var TraitEntryAttribute_1 = require("./TraitEntryAttribute");
var TraitEntryDateTime = (function () {
    function TraitEntryDateTime(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.name = data.name;
        this.desc = typeof data.desc !== 'undefined' ? data.desc : undefined;
        this.usingForTelemetry = typeof data.usingForTelemetry !== 'undefined' ? data.usingForTelemetry : undefined;
        this.default_AsString = data.default;
    }
    TraitEntryDateTime.prototype.getPackageName = function () { return TraitEntryDateTime.PackageName; };
    TraitEntryDateTime.prototype.getClassName = function () { return TraitEntryDateTime.ClassName; };
    TraitEntryDateTime.prototype.getFullClassName = function () { return TraitEntryDateTime.FullClassName; };
    Object.defineProperty(TraitEntryDateTime.prototype, "name", {
        get: function () {
            return this._name;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field name is not optional');
            }
            if (typeof value !== 'string') {
                throw new Error('Field name expects type string, got ' + value);
            }
            this._name = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TraitEntryDateTime.prototype, "desc", {
        get: function () {
            return this._desc;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._desc = undefined;
                return;
            }
            if (typeof value !== 'string') {
                throw new Error('Field desc expects type string, got ' + value);
            }
            this._desc = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TraitEntryDateTime.prototype, "usingForTelemetry", {
        get: function () {
            return this._usingForTelemetry;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._usingForTelemetry = undefined;
                return;
            }
            if (typeof value !== 'boolean') {
                throw new Error('Field usingForTelemetry expects boolean type, got ' + value);
            }
            this._usingForTelemetry = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TraitEntryDateTime.prototype, "default_", {
        get: function () {
            return this._default;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field default_ is not optional');
            }
            if (!(value instanceof Date)) {
                throw new Error('Field default_ expects type Date, got ' + value);
            }
            this._default = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TraitEntryDateTime.prototype, "default_AsString", {
        get: function () {
            return irt_1.Formatter.writeZoneDateTime(this._default);
        },
        set: function (value) {
            if (typeof value !== 'string') {
                throw new Error('default_AsString expects type string, got ' + value);
            }
            this._default = irt_1.Formatter.readZoneDateTime(value);
        },
        enumerable: false,
        configurable: true
    });
    TraitEntryDateTime.prototype.toTraitEntryAttributeSerialized = function () {
        return {
            name: this.name,
            desc: typeof this.desc !== 'undefined' ? this.desc : undefined,
            usingForTelemetry: typeof this.usingForTelemetry !== 'undefined' ? this.usingForTelemetry : undefined
        };
    };
    TraitEntryDateTime.prototype.toTraitEntryAttribute = function () {
        return new TraitEntryAttribute_1.TraitEntryAttributeStruct(this.toTraitEntryAttributeSerialized());
    };
    TraitEntryDateTime.prototype.toTraitEntryBaseSerialized = function () {
        return {
            name: this.name,
            desc: typeof this.desc !== 'undefined' ? this.desc : undefined,
            usingForTelemetry: typeof this.usingForTelemetry !== 'undefined' ? this.usingForTelemetry : undefined
        };
    };
    TraitEntryDateTime.prototype.toTraitEntryBase = function () {
        return new TraitEntryBase_1.TraitEntryBaseStruct(this.toTraitEntryBaseSerialized());
    };
    TraitEntryDateTime.prototype.loadTraitEntryAttributeSerialized = function (slice) {
        this.name = slice.name;
        this.desc = typeof slice.desc !== 'undefined' ? slice.desc : undefined;
        this.usingForTelemetry = typeof slice.usingForTelemetry !== 'undefined' ? slice.usingForTelemetry : undefined;
    };
    TraitEntryDateTime.prototype.loadTraitEntryAttribute = function (slice) {
        this.loadTraitEntryAttributeSerialized(slice.serialize());
    };
    TraitEntryDateTime.prototype.loadTraitEntryBaseSerialized = function (slice) {
        this.name = slice.name;
        this.desc = typeof slice.desc !== 'undefined' ? slice.desc : undefined;
        this.usingForTelemetry = typeof slice.usingForTelemetry !== 'undefined' ? slice.usingForTelemetry : undefined;
    };
    TraitEntryDateTime.prototype.loadTraitEntryBase = function (slice) {
        this.loadTraitEntryBaseSerialized(slice.serialize());
    };
    TraitEntryDateTime.prototype.serialize = function () {
        return {
            name: this.name,
            desc: typeof this.desc !== 'undefined' ? this.desc : undefined,
            usingForTelemetry: typeof this.usingForTelemetry !== 'undefined' ? this.usingForTelemetry : undefined,
            default: this.default_AsString
        };
    };
    TraitEntryDateTime.PackageName = 'net.playq.octopus2.analytics';
    TraitEntryDateTime.ClassName = 'TraitEntryDateTime';
    TraitEntryDateTime.FullClassName = 'net.playq.octopus2.analytics.TraitEntryDateTime';
    return TraitEntryDateTime;
}());
exports.TraitEntryDateTime = TraitEntryDateTime;
TraitEntryAttribute_1.TraitEntryAttributeStruct.register(TraitEntryDateTime.FullClassName, TraitEntryDateTime);
TraitEntryBase_1.TraitEntryBaseStruct.register(TraitEntryDateTime.FullClassName, TraitEntryDateTime);
var irt_2 = require("@playq/irt");
irt_2.Introspector.register(TraitEntryDateTime.FullClassName, {
    full: TraitEntryDateTime.FullClassName,
    short: TraitEntryDateTime.ClassName,
    package: TraitEntryDateTime.PackageName,
    type: irt_2.IntrospectorTypes.Data,
    ctor: function () { return new TraitEntryDateTime(); },
    fields: [
        {
            name: 'name',
            accessName: 'name',
            type: { intro: irt_2.IntrospectorTypes.Str }
        },
        {
            name: 'desc',
            accessName: 'desc',
            type: { intro: irt_2.IntrospectorTypes.Opt, value: { intro: irt_2.IntrospectorTypes.Str } }
        },
        {
            name: 'usingForTelemetry',
            accessName: 'usingForTelemetry',
            type: { intro: irt_2.IntrospectorTypes.Opt, value: { intro: irt_2.IntrospectorTypes.Bool } }
        },
        {
            name: 'default',
            accessName: 'default_',
            type: { intro: irt_2.IntrospectorTypes.Tsz }
        }
    ]
});
//# sourceMappingURL=TraitEntryDateTime.js.map